export const notesTypes = {
  SET_NOTES_FILTERS: 'SET_NOTES_FILTERS',
  GET_NOTES: 'GET_NOTES',
  CLEAR_NOTES: 'CLEAR_NOTES',
  SET_CONFIG_FILTER_NOTES: 'SET_CONFIG_FILTER_NOTES',
  SET_CONFIG_PAGE_NOTES: 'SET_CONFIG_PAGE_NOTES',
  SET_CONFIG_PAGE_SIZE_NOTES: 'SET_CONFIG_PAGE_SIZE_NOTES',
  SET_CONFIG_SORTED_NOTES: 'SET_CONFIG_SORTED_NOTES',
};